import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  width: "16",
  height: "16",
  viewBox: "0 0 16 16",
  fill: "none",
  xmlns: "http://www.w3.org/2000/svg",
  class: "fill-current"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("g", { id: "KO Dot container" }, [
      _createElementVNode("circle", {
        id: "KO Dot",
        cx: "8",
        cy: "8",
        r: "5",
        fill: "#E4E4E7"
      })
    ], -1)
  ])))
}
export default { render: render }